<template>
    <div class="my-wallet">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div class="qb-bottom">
            <div class="qb-one">
                <div class="qb-two">
                    <div class="qb-top">
                        <div style="width: 40px;">
                            <img v-if="member&&member.headPortrait" :src="member.headPortrait" class="my-tou"/>
                            <div v-else>
                                <img v-if="member.sex==0" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="member.sex==1" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="member.sex==2" src="./../../assets/nv.png" class="my-tou"/>
                            </div>
                        </div>
                        <div class="qb-mbinfo" v-if="member&&member.memberName">
                            <span style="font-size: 10px;height: 10px;color: #FFFFFF;height: 13px;line-height: 12px">{{member.memberName}}</span>
                            <span style="font-size: 10px;height: 10px;color: #FFFFFF;height: 13px;line-height: 12px">{{member.phone}}</span>
                            <div class="qb-mbgn" v-if="member.idName">
                                <span style="font-size: 9px;background-color: gainsboro;padding: 3px 10px;">{{member.idName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="qb-yue">
                    <div class="qb-val">
                        <div class="qb-val-item">
                            <span style="color: #FFFFFF;font-size: 13px">{{member.goldCoin==null?'0':member.goldCoin}}</span>
                            <span style="color: #FFFFFF;font-size: 13px;margin-top: 8px">金豆账户</span>
                        </div>
                    </div>
                    <div class="qb-yxj">
                        <div class="qb-tc">
                            <div class="qb-tx" style="background-color: #2E3191" @click="toCz">
                                <span style="font-size: 15px;color: #FFFFFF">充值</span>
                            </div>
                        </div>
                    </div>
                    <div class="qb-yxj">
                        <div class="qb-tc1">
                            <div class="qb-tx">
                                <span style="font-size: 15px;color: #FFFFFF">提现</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu-btn">
                <div class="mt-item">
                    <span style="font-size: 13px"><span style="font-size: 10px">¥ </span>{{mm.sc}}</span>
                    <span style="font-size: 13px;margin-top: 12px">商城消费</span>
                </div>
                <div class="mt-item">
                    <span style="font-size: 13px"><span style="font-size: 10px">¥ </span>{{mm.md}}</span>
                    <span style="font-size: 13px;margin-top: 12px">到店消费</span>
                </div>
                <div class="mt-item">
                    <span style="font-size: 13px"><span style="font-size: 10px">¥ </span>{{mm.zsy}}</span>
                    <span style="font-size: 13px;margin-top: 12px">总收益</span>
                </div>
            </div>
            <div class="menu-btn">
                <div class="mt-item">
                    <van-icon class="iconfont icon-yipaidui" size="30" style="color: #2b94ff;display: block"/>
                    <span style="font-size: 13px;margin-top: 12px">排队免单</span>
                </div>
                <div class="mt-item" @click="revenueDetails">
                    <van-icon class="iconfont icon-fenxiangzhuanshouyi" size="30"
                              style="color: #2b94ff;display: block"/>
                    <span style="font-size: 13px;margin-top: 12px">收益明细</span>
                </div>
                <div class="mt-item">
                    <van-icon class="iconfont icon-tixian" size="30" style="color: #2b94ff;display: block"/>
                    <span style="font-size: 13px;margin-top: 12px">提现明细</span>
                </div>
            </div>
            <div class="jdccc">
                <div class="jdczjl">
                    <span>金豆充值记录</span>
                    <span @click="gengduo">更多</span>
                </div>
                <div class="jdinfo" v-for="item in jdList">
                    <div class="jdbt">
                        <span style="font-size: 12px;margin-bottom: 8px">充值金豆</span>
                        <span style="font-size: 9px;color: #AAAAAA">{{item.createTime}}</span>
                    </div>
                    <span style="color:#F68C42;font-size: 15px">+{{item.total}}</span>
                </div>
            </div>
        </div>
        <van-popup v-model="jdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 60%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>金豆充值</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="jdcz">
                <van-cell-group>
                    <van-field
                            label="金豆数量"
                            v-model="jdVal"
                            placeholder="请输入金豆"
                    />
                </van-cell-group>
                <span style="font-size: 12px;margin-left: 15px">注：虚拟金豆不兑现，不找零</span>
            </div>
            <div class="ljbtn">
                <van-button type="info" style="width: 100%;background-color: #8459FA" @click="saveMemberBean">立即充值
                </van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '数字钱包',
                deptId: '',
                token: '',
                member: {},

                idMap: {},

                jdShow: false,
                jdVal: '',

                jdPage: 1,
                jdList: [],
                mm: {
                    sc: 0,
                    md: 0,
                    zsy: 0,
                }
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
            this.getMyWallet()
            this.jdLoad()
            this.getSpmIncome()
        },
        methods: {

            async getMyWallet() {
                let res = await this.$get("/spm/getSpmMyWallet", {token: this.token})
                if (res.code == 200) {
                    this.member = res.member
                } else {
                }
            },

            async getSpmIncome() {
                let res = await this.$get("/spm/getSpmIncome", {token: this.token})
                this.mm = res.mm
            },

            async jdLoad() {
                let currentPage = this.jdPage || 1;
                let data = {
                    token: this.token,
                    reviewStatus: 2,
                    currentPage
                }
                let res = await this.$get("/spm/getSpmMemberBeanPage", data)
                this.jdList = res.dataSet.list
            },

            // async jdLoad() {
            //     let currentPage = this.jdPage || 1;
            //     let data = {
            //         token: this.token,
            //         currentPage
            //     }
            //     let res = await this.$get("/spm/getSpmMemberBeanPage", data)
            //     if (res.code == 200) {
            //         this.jdList = this.jdList.concat(res.dataSet.list)
            //         if (res.dataSet.list.length < 10) {
            //             this.jdFinished = true
            //             this.jdLoading = true;
            //         } else {
            //             // 加载状态结束
            //             this.jdLoading = false;
            //         }
            //         this.jdPage = this.jdPage + 1
            //     } else {
            //         this.jdFinished = true
            //     }
            // },

            toCz() {
                this.jdShow = true
                this.jdVal = ''
            },
            guanbi() {
                this.jdShow = false
            },
            async saveMemberBean() {
                let data = {
                    token: this.token,
                    jdVal: this.jdVal,
                    deptId: this.deptId
                }
                let res = await this.$post("/spm/saveSpmMemberBean", data)
                if (res.code == 200) {
                    this.$notify({message: res.message, duration: 1000, background: '#1989fa'});
                    this.getMyWallet()
                    this.guanbi()
                } else {
                    this.$notify({message: res.message, duration: 1000, background: 'red'});
                }
            },
            revenueDetails() {
                this.$router.push('/revenueDetails/' + this.deptId)
            },
            gengduo() {
                // this.$router.push('/mydata/' + this.deptId)
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-wallet {
        margin: 0 auto;
        height: 100%;
        background-size: 100% 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
        overflow: hidden;
    }

    .qb-top {
        height: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: auto;
        padding-top: 5px;
        padding-left: 16px;
    }

    .my-tou {
        width: 30px;
        height: 30px;
        border-radius: 50px;
    }

    .qb-mbinfo {
        display: flex;
        flex-direction: column;
    }

    .qb-mbgn {
        display: flex;
        flex-direction: row;
        margin-top: 3px;
        height: 15px;
    }

    .qb-bottom {
        border-top: #D5D5D5 solid 1px;
        background-color: #FFFFFF;
        width: 95%;
        margin: auto;
        height: 98%;
    }

    .qb-one {
        display: flex;
        flex-direction: column;
        height: 150px;
        background-color: #FFFFFF;
        width: 80%;
        margin: auto;
        margin-top: 20px;
    }

    .qb-two {
        background-color: #9086DF;
        height: 110px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    .qb-yue {
        display: flex;
        flex-direction: row;
        height: 70px;
        background-color: #FFFFFF;
        border-bottom-left-radius: 12px;
    }

    .qb-val {
        width: 60%;
        height: 100%;
        background-color: #9086DF;
        border-bottom-right-radius: 12px;
        border-bottom-left-radius: 12px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .qb-val-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
    }

    .qb-yxj {
        width: 28%;
        height: 100%;
        background-color: #9086DF;
    }

    .qb-tc {
        background-color: #FFFFFF;
        height: 100%;
        width: 100%;
        border-top-left-radius: 12px;
        padding-left: 10px;
        padding-top: 10px;
    }

    .qb-tc1 {
        background-color: #FFFFFF;
        height: 100%;
        width: 100%;
        padding-left: 10px;
        padding-top: 10px;
    }

    .qb-tx {
        width: 100%;
        height: 100%;
        background-color: #3F454C;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .menu-btn {
        width: 80%;
        margin: auto;
        margin-top: 25px;
        display: flex;
        flex-direction: row;
    }

    .mt-item {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 8px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .jdcz {
    }

    .ljbtn {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .jdccc {
        margin-top: 30px;
        padding: 0 20px;
    }

    .jdczjl {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        border-bottom: silver solid 1px;
        padding: 8px 3px;
    }

    .jdinfo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px 10px;
    }

    .jdbt {
        display: flex;
        flex-direction: column;
    }

</style>
